<template>
  <v-card>
    <v-card-title>
      Manager List
    </v-card-title>
    <v-card-subtitle>
      View all of your managers
    </v-card-subtitle>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table-thead, table-tbody"
      ></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="managers"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
        @click:row="rowClick"
        class="row-pointer"
      >
        <template v-slot:item.fullName="{ item }">
          <user-chip :user="item"></user-chip>
        </template>
        <template v-slot:item.fullTeamName="{ item }">
          <team-chip
            v-if="item.teamId"
            :team="{
              id: item.teamId,
              fullName: item.fullTeamName,
              logoUrl: item.teamLogoUrl
            }"
          ></team-chip>
        </template>
        <template v-slot:item.coreBoard="{ item }">
          <v-btn
            icon
            @click.stop="
              $router.push({ path: '/members/' + item.id + '/coreboard' })
            "
          >
            <v-icon>insert_chart</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            text
            class="light-background"
            small
            color="info"
            :to="'/members/' + item.id"
          >
            View
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ManagerList",
  components: {},
  data: () => ({
    loading: true,
    headers: [
      { text: "Name", value: "fullName" },
      { text: "Department", value: "fullTeamName" },
      { text: "CoreBoard", value: "coreBoard", sortable: false },
      { text: "Actions", value: "actions", sortable: false }
    ]
  }),
  computed: {
    ...mapGetters({
      managers: "user/managers"
    })
  },
  created() {
    this.getManagers();
  },
  methods: {
    getManagers() {
      this.$store
        .dispatch("user/getManagers", this.options)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your managers."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$router.push({ path: "/members/" + item.id });
    }
  }
};
</script>
